import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6287645a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = {
  key: 1,
  class: "quest"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Далее")
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Примеры", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_it_alert = _resolveComponent("it-alert")!
  const _component_it_progressbar = _resolveComponent("it-progressbar")!
  const _component_it_button = _resolveComponent("it-button")!
  const _component_it_tooltip = _resolveComponent("it-tooltip")!
  const _component_it_badge = _resolveComponent("it-badge")!
  const _component_WordExamples = _resolveComponent("WordExamples")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoadingErrorVisible)
      ? (_openBlock(), _createBlock(_component_it_alert, {
          key: 0,
          type: "danger",
          title: 'Ошибка. Не удалось загрузить данные',
          style: {"margin":"50px 0"},
          body: 'Попробуйте обновить страницу, ' +
     'а если ничего не изменилось то можете сообщить об ошибке.'
        }, null, 8, ["title", "body"]))
      : _createCommentVNode("", true),
    _createElementVNode("h4", null, "Статистика (попыток: " + _toDisplayString(_ctx.getTotalAttempts) + ", успешных: " + _toDisplayString(_ctx.stats.attemptsSucceeded) + ")", 1),
    _createVNode(_component_it_progressbar, {
      height: 5,
      progress: _ctx.getSuccessRatio,
      style: {"margin-top":"25px","margin-bottom":"10px","width":"80%"}
    }, null, 8, ["progress"]),
    _hoisted_1,
    (_ctx.randomWord != null)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.randomWord.translation), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.words, (word, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: word.id
            }, [
              _createVNode(_component_it_badge, {
                value: index + 1,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_it_tooltip, {
                    content: _ctx.isQuestFinished ? word.translation : '😉',
                    placement: "right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_it_button, {
                        onClick: ($event: any) => (_ctx.onWordChosen(index + 1)),
                        type: _ctx.getWordColor(index + 1)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(word.word), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "type"])
                    ]),
                    _: 2
                  }, 1032, ["content"])
                ]),
                _: 2
              }, 1032, ["value"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createVNode(_component_it_button, {
      style: {"margin":"0 auto"},
      onClick: _ctx.onEnterPressed
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.isExamplesDisplayed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_WordExamples, { words: _ctx.words }, null, 8, ["words"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_it_button, {
      style: {"display":"none"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$Loading.start())),
      ref: "LoadingBarStartButton"
    }, null, 512),
    _createVNode(_component_it_button, {
      style: {"display":"none"},
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$Loading.finish())),
      ref: "LoadingBarFinishButton"
    }, null, 512)
  ], 64))
}